import Marquee from "react-fast-marquee";

const items = [
  "Budgeting",
  "Saving Habits",
  "Investing Basics",
  "Debt Freedom",
  "Emergency Funds",
  "Wealth Mindset",
];

const EditorialMarquee = () => (
  <section data-testid="marquee" className="border-y border-border bg-secondary py-6 md:py-8">
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((it, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-3xl font-medium italic text-primary md:text-5xl">
            {it}
          </span>
          <span className="mx-8 text-2xl text-primary/50 md:mx-12 md:text-4xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
